import { render } from "./LiveText.vue?vue&type=template&id=ef7d5b52&scoped=true"
import script from "./LiveText.vue?vue&type=script&lang=ts"
export * from "./LiveText.vue?vue&type=script&lang=ts"

import "./LiveText.vue?vue&type=style&index=0&id=ef7d5b52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef7d5b52"

export default script